// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"AddRedirect_pageContainer__1fnXq","heading":"AddRedirect_heading__oXvRz"};